import * as React from 'react'
import Typography from '../Typography'
import PhoneCTA from '../PhoneCTA'

const MegaFormSubmissionMessage = () => (
  <>
    <Typography variant="h4">Your FREE quote is ready!</Typography>
    <PhoneCTA variant="hero">Call Now!</PhoneCTA>
  </>
)

export default MegaFormSubmissionMessage
